import { setMany } from 'idb-keyval';
import { postData } from '@lib/helpers';
import { BASE_URL } from '@lib/constants';

const setSections =
	({
		sections = {},
		newData = {},
		updateSections = false,

		existingActive = {},
		existingInActive = {},
		fromCache = false,
		validateData = false,
	}) =>
	async (dispatch) => {
		let payload = {};
		const deprecatedSections = [];
		let personalisedData = [];

		// This will append new sections not set in selected order.

		// Needs to use the new structure but keep the old posts.

		const newSections = !fromCache ? { ...sections, ...newData } : sections;
		const newSectionData = newSections;

		// Merged sections, this gives us an idea of the headers available to us.
		if (updateSections) {
			Object.keys(newSections).forEach((name) => {
				if ('undefined' === typeof existingActive[name]) {
					existingActive[name] = {};
					existingActive[name].articles = [];
				}

				if ('undefined' === typeof existingInActive[name]) {
					existingInActive[name] = {};
					existingInActive[name].articles = [];
				}

				// If a section has been removed since saving.
				// Should only do this if this is not the users saved prospectus.
				if ('undefined' === typeof newData[name]) {
					delete newSections[name];
				}
			});

			payload = {
				sections: newSections,
				deprecatedSections: deprecatedSections,
				activeSections: existingActive,
				inActiveSections: existingInActive,
			};
		}

		const potentiallyNewList = {};

		// We need to perform a loop to check if anything has been removed.

		// A loop to find new cards that need to be active.
		if (Object.keys(newSectionData).length > 0) {
			Object.keys(newSectionData).forEach((name) => {
				// If we have new data & sections.
				if ('undefined' !== typeof newData[name] && 'undefined' !== typeof newData[name]['articles']) {
					if (newData[name]['articles'].length > 0) {
						if ('undefined' === typeof potentiallyNewList[name]) {
							potentiallyNewList[name] = [];
							potentiallyNewList[name]['articles'] = [];
						}

						newData[name]['articles'].forEach((article) => {
							// Conditional checks if the section exists with articles.
							if (
								'undefined' !== typeof existingInActive[name] &&
								'undefined' !== typeof existingInActive[name]['articles'] &&
								existingInActive[name]['articles'].length > 0
							) {
								// This only checks if the article exists.
								// If it does it does nothing. This is not helpful as it will still show old titles, links etc.

								// We need to update the data of this id if it exists.

								const IDExists = existingInActive[name]['articles'].findIndex(
									(existing) => article.id === existing.id
								);

								// Checks if the id exists.
								// article not in inActive list, so add it to a potentiallyNewList.
								if (IDExists < 0) {
									potentiallyNewList[name]['articles'].push(article);
								} else {
									// Update index.
									existingInActive[name]['articles'][IDExists] = article;
								}
							} else {
								potentiallyNewList[name]['articles'].push(article);
							}
						});
					}
				}
			});
		}

		// A loop to find out if the stuff that wasn't added to bin is already in active, if not add it.
		if (Object.keys(potentiallyNewList).length > 0) {
			Object.keys(potentiallyNewList).forEach((name) => {
				potentiallyNewList[name]['articles'].forEach((article) => {
					if (
						'undefined' !== typeof existingActive[name] &&
						'undefined' !== typeof existingActive[name]['articles']
					) {
						// This just needs to be another find index.
						// If -1 it doesn't exist.
						// Else it does & we should update the content.

						const activeIDExists = existingActive[name]['articles'].findIndex(
							(existingArticle) => article.id === existingArticle.id
						);

						// article not in Active list, so add it to a potentiallyNewList.
						if (activeIDExists < 0) {
							// Remove from inactive if it exists there
							const inactiveIndex = existingInActive[name]?.articles?.findIndex(
								(a) => a.id === article.id
							);

							if (inactiveIndex >= 0) {
								existingInActive[name].articles.splice(inactiveIndex, 1);
							}
							existingActive[name]['articles'].push(article);
						} else {
							existingActive[name]['articles'][activeIDExists] = article;
						}
					}
				});
			});
		}

		/**
		 * Removes data from non-personalised fields.
		 */
		if (validateData) {
			if (Object.keys(newSectionData).length > 0) {
				Object.keys(newSectionData).forEach((name) => {
					// Only loop non-personalised articles.
					if (!newSectionData[name]['is_personalisation']) {
						// newData
						// Loop existing active to check if we have old articles.
						existingActive[name]['articles'].forEach((article, key) => {
							if (
								'undefined' !== typeof newData[name] &&
								'undefined' !== typeof newData[name]['articles']
							) {
								const idStillExists = newData[name]['articles'].findIndex(
									(newArticle) => article.id === newArticle.id
								);

								if (-1 === idStillExists) {
									// keysToRemove.push(key);
									existingActive[name]['articles'].splice(key, 1);
								}
							}
						});

						existingInActive[name]['articles'].forEach((inactiveArticle, key) => {
							if (
								typeof newData[name] !== 'undefined' &&
								typeof newData[name]['articles'] !== 'undefined'
							) {
								existingInActive[name]['articles'] = existingInActive[name]['articles'].filter(
									(inactiveArticle) =>
										newData[name]['articles'].some(
											(newArticle) => newArticle.id === inactiveArticle.id
										)
								);
							}
						});
					} else {
						existingActive[name]['articles'].forEach((article, key) => {
							personalisedData.push(article.id);
						});

						existingInActive[name]['articles'].forEach((inactiveArticle, key) => {
							personalisedData.push(inactiveArticle.id);
						});
					}
				});
			}
		}

		payload.activeSections = existingActive;
		payload.inActiveSections = existingInActive;

		if (!fromCache) {
			if (validateData) {
				const validatePersonalisationData = await postData(`${BASE_URL}/wp-json/edu_api/validate`, {
					posts: personalisedData,
				});

				if (validatePersonalisationData.length > 0) {
					if (Object.keys(newSectionData).length > 0) {
						Object.keys(newSectionData).forEach((name) => {
							// Only loop non-personalised articles.
							if (newSectionData[name]['is_personalisation']) {
								// newData
								// Loop existing active to check if we have old articles.
								existingActive[name]['articles'].forEach((article, key) => {
									validatePersonalisationData.forEach((removeId) => {
										if (removeId === article.id) {
											existingActive[name]['articles'][key]['post_status'] = 'trash';
										}
									});
								});

								existingInActive[name]['articles'].forEach((inactiveArticle, key) => {
									validatePersonalisationData.forEach((removeId) => {
										if (removeId === inactiveArticle.id) {
											existingActive[name]['articles'][key]['post_status'] = 'trash';
										}
									});
								});
							}
						});
					}
				}
			}

			setMany([
				['sections', payload.sections],
				['activeSections', payload.activeSections],
				['inActiveSections', payload.inActiveSections],
			]).then(() => {
				dispatch({
					type: 'SET_SECTIONS',
					payload: payload,
				});
			});
		} else {
			dispatch({
				type: 'SET_SECTIONS',
				payload: payload,
			});
		}
	};

export default setSections;
